import {TenantFeedbackTypes} from "./tenant-feedback-types";

export class TenantFeedbackPost {
    score: number;
    feedbackType: TenantFeedbackTypes;
    comments: string;
}
